export const ORDERS: string = "orders";
export const ORDER_ITEMS_PLACE: string = "orders/:orderId/order-items/:orderItemId/place";
export const ORDER_ITEMS_CANCEL: string = "orders/:orderId/order-items/:orderItemId/cancel";

export const REPORTS_ORDERS_SUMMARY: string = "reports/orders/summary";
export const REPORTS_ORDERS_ITEMS: string = "reports/orders/items";
